import { classes } from 'html-classes';
import { FC, ReactNode } from 'react';

import styles from './Switch.module.scss';

export interface SwitchProps {
  label: string | ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
  disabled?: boolean;
  name?: string;
  isCompact?: boolean;
  labelPosition?: 'left' | 'right';
}

export const Switch: FC<SwitchProps> = ({
  label,
  value,
  onChange,
  className,
  disabled = false,
  name,
  isCompact = false,
  labelPosition = 'right',
}) => {
  return (
    <label
      className={classes([
        styles.switch,
        className,
        disabled && styles.disabled,
        labelPosition === 'left' && styles.labelLeft,
      ])}
    >
      <input
        type="checkbox"
        checked={value}
        className={styles.input}
        onChange={() => onChange(!value)}
        disabled={disabled}
        name={name}
      />
      <span className={styles.mark} />
      <div className={styles.textWrapper}>
        <div className={classes([styles.label, isCompact && styles.reversed])}>
          {label}
        </div>
      </div>
    </label>
  );
};
